/**
 * メインビジュアル用のスライダーコンテンツ
 *  ※Swiperのライブラリが読み込まれている前提
 */
export default class MVSlider extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.id;
    const swiper = new Swiper(`unico-mv-slider[data-id="${this.id}"] .swiper`, {
      slidesPerView: 1.1,
      spaceBetween: 10,
      loop: true,
      centeredSlides: true,
      paginationClickable: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      pagination: {
        el: 'unico-mv-slider .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: 'unico-mv-slider .swiper-button-next',
        prevEl: 'unico-mv-slider .swiper-button-prev',
      },
      breakpoints: {
        769: {
          slidesPerView: 'auto',
        }
      }
    });
  }
}
